import { Component } from '@angular/core';

@Component({
    selector: 'gbc-static-text-field',
    templateUrl: './static-text-field.component.html',
    styleUrls: ['./static-text-field.component.scss'],
    standalone: true
})
export class StaticTextFieldComponent {
}
